<template>
  <div id="app">
      <router-view />
  </div>
</template>

<script>
export default {
  name:'app',
  data(){
    return {}
  }
}
</script>

<style>
*,body{
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
#app{
  position: relative;
  /* background-color: #000; */
  height: 100vh;
}

</style>



// WEBPACK FOOTER //
// src/App.vue